import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment, Router, UrlTree } from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanLoad {
  constructor(private router: Router, private authService: AuthService) {}

  canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean> {
    if (this.authService.getLoggedUserData()) {
      return true;
    }
    if (this.authService.checkIfTokenPresent()) {
      return this.authService.fetchProfile().pipe(map(({ success }) => success));
    } else {
      this.storeTargetPageUrl(segments);

      return this.router.parseUrl('auth/sign-in');
    }
  }

  private storeTargetPageUrl(segments: UrlSegment[]): void {
    const initialNavigationUrl = segments.map(segment => segment.path).join('/');
    this.authService.initialNavigationUrl = initialNavigationUrl;
  }
}
